import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import useCheckResetToken from '@app/data/ForgotPassword/useCheckResetToken';
import LoadingState from '@app/Components/LoadingState/LoadingState';
import { useResetStore } from '@app/store/resetPasswordStore';
import { useLoginVault } from '@app/store/authStore';
import { useLoggedIn } from '@app/ACL/useLogin';
import { ROUTES } from '@app/AppRoutes/routes';

import { EResetStatus } from '../types';
import { Flex } from '@zeal/web-ui';

export enum ETokensStatusCode {
	EXPIRED = 403,
	LINK_USED_BEFORE = 410,
	INVALID_LINK = 400,
}

const CheckResetToken = () => {
	const [searchParams] = useSearchParams();
	const hasCheckedToken = React.useRef<boolean>(false);
	const token = searchParams.get('token');

	const navigate = useNavigate();
	const { id } = useLoginVault();
	const { token: userToken } = useLoggedIn();

	const { setToken, setResetStatus } = useResetStore();

	const { doCheckResetToken } = useCheckResetToken({
		onError: async (rawError: {
			message?: string | undefined;
			statusCode: number;
		}) => {
			const isLinkUsedBefore =
				rawError.statusCode === ETokensStatusCode.LINK_USED_BEFORE;
			const isLinkExpired = rawError.statusCode === ETokensStatusCode.EXPIRED;
			if (isLinkUsedBefore) {
				setResetStatus(EResetStatus.LINK_USED_BEFORE);
			} else if (isLinkExpired) {
				setResetStatus(EResetStatus.EXPIRED);
			} else {
				setResetStatus(EResetStatus.INVALID_LINK);
			}
		},
		onSuccess: () => {
			setResetStatus(EResetStatus.VALID);
		},
	});

	React.useEffect(() => {
		if (!hasCheckedToken.current) {
			const isUserLoggedIn = id || userToken;
			if (isUserLoggedIn) {
				navigate(ROUTES.HOME.path);
			} else if (token) {
				hasCheckedToken.current = true;
				setToken(token);
				doCheckResetToken({ token });
			} else {
				navigate(ROUTES.ROOT.path);
			}
		}
	});
	return (
		<Flex align="center" justify="center" className="h-full">
			<LoadingState />
		</Flex>
	);
};

export default CheckResetToken;
